"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadCrumb = exports.BreadCrumbs = void 0;

var _react = _interopRequireDefault(require("react"));

var _ri = require("react-icons/ri");

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BreadCrumbs = function BreadCrumbs(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: containerCSS
  }, children);
};

exports.BreadCrumbs = BreadCrumbs;

var BreadCrumb = function BreadCrumb(_ref2) {
  var children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'default' : _ref2$variant;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: breadCrumbCSS({
      variant: variant
    })
  }, /*#__PURE__*/_react["default"].createElement(_.Text, null, children), variant === 'faded' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    size: 0.5
  }), /*#__PURE__*/_react["default"].createElement(_ri.RiArrowRightSLine, {
    size: 14
  })));
};

exports.BreadCrumb = BreadCrumb;

var containerCSS = function containerCSS() {
  return {
    display: 'flex'
  };
};

var breadCrumbCSS = function breadCrumbCSS(_ref3) {
  var variant = _ref3.variant;
  return function (_ref4) {
    var _ref4$theme = _ref4.theme,
        grid = _ref4$theme.grid,
        colors = _ref4$theme.colors;
    return _objectSpread({
      display: 'flex',
      marginRight: grid,
      color: colors.body
    }, variant === 'faded' && {
      color: colors.bodySecondary,
      '& > p': {
        color: colors.bodySecondary
      }
    });
  };
};